import { Component, Input, OnInit } from '@angular/core';
import { CoOpService } from '../../services/co-op.service';
import { EfoElevateService } from '../../services/elevate.service';
import * as moment from 'moment';

@Component({
  selector: 'co-op-mailer',
  templateUrl: './co-op-mailer.component.html',
  styleUrls: ['./co-op-mailer.component.css'],
})
export class CoOpMailerComponent implements OnInit {
  @Input() coOp: any;

  sendingEmail = false;
  email: any = {
    to: '',
    cc: '',
    subject: '',
    body: '',
  };

  constructor(
    private coOpService: CoOpService,
    private efoElevateService: EfoElevateService,
  ) {}

  async ngOnInit(): Promise<void> {
    const res = await this.efoElevateService
      .getDealer(this.coOp.account_num)
      .toPromise();
    const allCoOps = await this.coOpService
      .getAllByAccount(this.coOp.account_num)
      .toPromise();
    const coOpEmail = allCoOps.find((coOp) => coOp?.data?.email?.to)?.data
      ?.email?.to;
    const month = moment(this.coOp.month, 'MMMYY').format('MMMM');
    this.email = {
      to: this.coOp?.data?.email?.to || coOpEmail || '',
      cc: 'jowensby@edificegroup.com',
      subject: `${res.dealer_name} ${month} Co-Op Documents`,
      body: `Hi,

Here are your ${month} co-op documents for submission. Please let me know if you have any questions or need anything else.

Thanks,

Jessica Owensby
Director of Revenue Operations
E: jowensby@edificegroup.com
C: 678-492-0935
www.EdificeAutoMarketing.com`, // DO NOT CHANGE FORMAT OR ELSE EMAIL WILL LOOK BAD
    };
  }

  sendEmail() {
    if (this.email?.to && this.email?.subject && this.email?.body) {
      this.sendingEmail = true;
      this.coOpService.sendEmail(this.coOp.id, this.email).subscribe(
        (res) => {
          this.sendingEmail = false;
          alert('Email sent successfully');
        },
        (err) => {
          this.sendingEmail = false;
          alert(`Error sending email: ${err.message}`);
        },
      );
    } else {
      alert(`Please fill out atleast 'To', 'Subject' and 'Body' fields`);
    }
  }
}
